module.exports = __webpack_public_path__ + "static/media/chevron-right.1e24c049.svg";